import React from "react";
import Icon from "components/AppIcon";
import Image from "components/AppImage";

const user = {
  name: "Alexandra Chen",
  title: "Growth Member",
  experienceLevel: "Intermediate",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1230b9d-1763294070661.png",
  avatarAlt: "Professional Asian woman with shoulder-length black hair wearing elegant navy blazer and warm smile",
  memberSince: "Jan 2025",
  isFoundingMember: true,
  streak: 14
};

const experienceBadgeColors = {
  Beginner: { bg: "rgba(5,150,105,0.12)", text: "#059669" },
  Intermediate: { bg: "rgba(133,113,77,0.15)", text: "var(--color-accent)" },
  Advanced: { bg: "rgba(0,48,87,0.12)", text: "var(--color-primary)" }
};

export default function WelcomeHeader() {
  const badge = experienceBadgeColors?.[user?.experienceLevel] || experienceBadgeColors?.Intermediate;
  const now = new Date();
  const hour = now?.getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      {/* Left: Avatar + Greeting */}
      <div className="flex items-center gap-3 md:gap-4 min-w-0">
        <div className="relative flex-shrink-0">
          <div
            className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden"
            style={{ border: "2px solid var(--color-accent)" }}>
            
            <Image
              src={user?.avatar}
              alt={user?.avatarAlt}
              className="w-full h-full object-cover" />
            
          </div>
          {user?.isFoundingMember &&
          <div
            className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center"
            style={{ background: "var(--color-accent)", border: "2px solid var(--color-background)" }}>
            
              <Icon name="Crown" size={10} color="var(--color-primary)" strokeWidth={2.5} />
            </div>
          }
        </div>
        <div className="min-w-0">
          <p className="font-caption text-xs md:text-sm" style={{ color: "var(--color-muted-foreground)" }}>
            {greeting},
          </p>
          <h1 className="font-heading font-semibold text-xl md:text-2xl leading-tight truncate" style={{ color: "var(--color-foreground)" }}>
            {user?.name}
          </h1>
          <div className="flex items-center gap-2 mt-0.5 flex-wrap">
            <span
              className="font-caption text-xs font-semibold px-2 py-0.5 rounded-full"
              style={{ background: badge?.bg, color: badge?.text }}>
              
              {user?.experienceLevel}
            </span>
            {user?.isFoundingMember &&
            <span
              className="font-caption text-xs font-semibold px-2 py-0.5 rounded-full flex items-center gap-1"
              style={{ background: "rgba(133,113,77,0.15)", color: "var(--color-accent)" }}>
              
                <Icon name="Crown" size={10} color="var(--color-accent)" />
                Founding Member
              </span>
            }
          </div>
        </div>
      </div>
      {/* Right: Stats */}
      <div className="flex items-center gap-3 md:gap-4 flex-shrink-0">
        <div className="text-center hidden sm:block">
          <div className="flex items-center gap-1 justify-center">
            <Icon name="Flame" size={14} color="#f97316" />
            <span className="font-data font-bold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
              {user?.streak}
            </span>
          </div>
          <p className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>day streak</p>
        </div>
        <div
          className="h-8 w-px hidden sm:block"
          style={{ background: "var(--color-border)" }} />
        
        <div className="text-center hidden sm:block">
          <p className="font-data font-bold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
            {user?.title}
          </p>
          <p className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
            Since {user?.memberSince}
          </p>
        </div>
        {/* Notification Bell */}
        <button
          className="relative w-10 h-10 rounded-lg flex items-center justify-center transition-all"
          style={{ background: "var(--color-muted)" }}
          aria-label="Notifications">
          
          <Icon name="Bell" size={18} color="var(--color-foreground)" strokeWidth={1.75} />
          <span
            className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full"
            style={{ background: "var(--color-accent)" }} />
          
        </button>
      </div>
    </div>);

}